import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { fetchDiocesan } from '@/services/api';

interface DiocesanInfo {
  photo: string;
  name: string;
}

const BishopWelcome = () => {
  const [diocesan, setDiocesan] = useState<DiocesanInfo | null>(null);

  useEffect(() => {
    const loadDiocesan = async () => {
      try {
        const res = await fetchDiocesan();
        setDiocesan(res.data[0]); // Because it's returned as an array
      } catch (err) {
        console.error('Failed to fetch diocesan info:', err);
      }
    };
    loadDiocesan();
  }, []);

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-stretch">
          {/* Text Section */}
          <div className="flex">
            <Card className="flex-grow shadow-md">
              <CardContent className="p-8">
                <h2 className="text-3xl font-bold text-purple-700 mb-2 font-raleway">
                  Welcome Message
                </h2>
                <hr className="w-24 border-t-2 border-purple-700 mb-6" />

                <div className="space-y-4 text-gray-800 text-lg leading-relaxed">
                  <p>
                    Greetings in the name of our Lord Jesus Christ.
                    We are honored to have you here with us. Our mission remains steadfast—
                    to spread the love of Christ and serve our community with compassion, faith, and integrity.
                  </p>
                  <p>
                    It is our hope that this website will not only meet your needs but also offer a window
                    into the life and mission of our Diocese.
                  </p>
                  <p>
                    As you explore our online presence, may God’s grace and peace accompany you and your loved ones.
                    We humbly ask for your prayers for our Diocese and its ministry as we pray for you and your family.
                    May God’s blessings abound in your life.
                  </p>
                </div>

                <div className="mt-8">
                  <p className="font-bold text-purple-700 text-lg">
                    {diocesan?.name || 'Rt. Rev. AkinTunde Adedayo Popoola'}
                  </p>
                  <p className="text-purple-500">
                    Bishop, Diocese of Ibadan South
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Image Section */}
          <div className="flex items-center justify-center">
            <div className="rounded-lg shadow-xl overflow-hidden w-full h-full">
              <img
                src={diocesan?.photo || '/img/the_diocesan1.jpg'} // Fallback
                alt={diocesan?.name || 'Bishop of Ibadan South'}
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BishopWelcome;
